import { render, staticRenderFns } from "./SortByRecs.vue?vue&type=template&id=5962f8df&"
import script from "./SortByRecs.vue?vue&type=script&lang=js&"
export * from "./SortByRecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports